import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const ProfileSelection = () => {
  const [SelectType, setSelectType] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleContinue = () => {
    if (!SelectType) {
      setError("Please select a profile type to continue");
      return;
    }
    setError("");

    if (SelectType === "I am a Freelancer") {
      navigate("/profileCreation/freelancer");
    } else if (SelectType === "Company") {
      navigate("/profileCreation/company");
    }
  };

  return (
    <>
      <div className="bg-gray-100">
        <div className="w-[15%] h-2 bg-primarygreen rounded-r-full"></div>
      </div>
      <div className="flex justify-center items-center py-10">
        <div className="py-4 px-6 bg-white w-[95%] md:w-[50%] xl:w-[30%] max-h-[70vh] overflow-y-auto mt-16 h-fit rounded-xl relative z-40 m-auto">
          <h2 className="text-lg md:text-2xl font-pop font-semibold mb-4">
            Welcome to Paycott.
          </h2>
          <p className="text-gray-600 mb-6 text-sm md:text-base max-w-sm">
            Choose between
          </p>
          <div className="flex flex-col font-pop gap-4">
            <div
              className={`flex font-medium flex-row border-2 items-center border-[#E9E9E9] py-2 md:py-4 px-2 md:px-6 rounded-lg gap-2 cursor-pointer ${SelectType === "I am a Freelancer" &&
                "border-primarygreen bg-primarygreen/30"
                }`}
              onClick={() => {
                setSelectType("I am a Freelancer");
                setError("");
              }}
            >
              <h3>I am a Freelancer</h3>
            </div>
            <div
              className={`flex font-medium flex-row border-2 items-center border-[#E9E9E9] py-2 md:py-4 px-2 md:px-6 rounded-lg gap-2 cursor-pointer ${SelectType === "Company" &&
                "border-primarygreen bg-primarygreen/30"
                }`}
              onClick={() => {
                setSelectType("Company");
                setError("");
              }}
            >
              <h3>Company</h3>
            </div>
          </div>
          {error && (
            <p className="text-red-500 text-sm mt-2">{error}</p>
          )}
          <div
            className={`bg-primarygreen my-4 text-center w-full border-2 border-primarygreen rounded-full font-pop text-white py-2 px-5 cursor-pointer ${!SelectType ? "opacity-50" : ""
              }`}
            onClick={handleContinue}
          >
            Continue
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfileSelection;
